/**
 * "+ Direct" button — attaches a direct-redirect lander entry to the path.
 * Maps to Binom's convention `{id: 0}` on customRotation paths (no LP).
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import { Zap } from 'lucide-react';

import { Button } from '@/components/ui/layout/Button';

import type { BinomDraftItem } from '../../../binom-flow-draft.types';

export interface BinomDirectLanderButtonProps {
  onAttach: (item: BinomDraftItem) => void;
}

const DIRECT_ITEM: BinomDraftItem = {
  id: '0',
  name: 'Direct redirect',
  weight: 100,
  originalWeight: 100,
  active: true,
  originalActive: true,
};

const BinomDirectLanderButton: FC<BinomDirectLanderButtonProps> = ({
  onAttach,
}) => (
  <Button
    type="button"
    variant="ghost"
    size="sm"
    className="h-6 gap-1 px-1.5 text-[10px]"
    onClick={() => onAttach({ ...DIRECT_ITEM })}
    aria-label="Attach direct redirect"
    title="No landing page — direct to offer"
  >
    <Zap className="h-3 w-3" aria-hidden /> Direct
  </Button>
);

export default BinomDirectLanderButton;
